/* src/app/library/library.component.scss */
.notice {
  background: #3D3F47;
  padding: 100px 0px;
}
.complete-training-overlay {
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 350px;
  left: 0px;
}
.content-library {
  text-align: left;
  padding: 50px 0px;
  width: 1200px;
  margin: 0 auto;
}
.content-library.themed {
  width: 100%;
  max-width: none;
  margin-top: -80px;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
  padding: 30px 0 0 0;
  box-sizing: border-box;
}
.content-library h2 {
  color: #FFF;
  font-family: "Campton-Bold";
  font-size: 34px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px;
}
.badges {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  margin-top: 15px;
  margin-bottom: 15px;
}
.badges .badge-type {
  color: #3D3F47;
  text-transform: uppercase;
  display: inline-block;
  border-radius: 5px;
  padding: 2px 5px;
  text-align: center;
  font-family: "Campton-bold";
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 4px 6px 2px 6px;
  border-radius: 5px;
}
.badges .badge-type.duration {
  background-color: #272A33;
  color: #C4C4C4;
  margin-left: 10px;
}
.badges .badge-type.type-practical {
  background: #50ACD4;
}
.badges .badge-type.badge-type-video {
  background: #FF9191;
}
.badges .badge-type.badge-type-podcast {
  background: #65BEA1;
}
.badges .badge-type.badge-type-research {
  background: #FF9258;
}
.badges .badge-type.badge-type-insights {
  background: #A891C7;
}
.badges .badge-type.badge-type-practical {
  background: #50ACD4;
}
.badges .badge-type.badge-type-reflection {
  background: #A891C7;
}
.badges .badge-type.badge-type-link {
  background: #50ACD4;
}
.badges .complete {
  margin-left: auto;
  margin-right: -5px;
}
.badges .complete svg {
  fill: #3D3F47;
}
.content-filter {
  display: flex;
  margin: 30px 0px;
  font-family: "Campton-Bold";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.7px;
  text-transform: uppercase;
}
.content-filter .separator {
  width: 1px;
  border-right: 1px solid #3D3F47;
  margin: 0 20px 0 0px;
}
.content-filter .filter-button {
  margin-right: 20px;
  border-radius: 20px;
  padding: 12px 20px 9px 20px;
}
.content-filter .filter-button:hover {
  cursor: pointer;
}
.content-filter .filter-button {
  background: #3D3F47;
  box-sizing: border-box;
  border: 1px solid #3D3F47;
  text-transform: uppercase;
}
.content-filter .filter-button.all {
  background: #3D3F47;
  color: white;
}
.content-filter .filter-button.all:hover {
  border: 1px solid white;
}
.content-filter .filter-button.all.selected {
  color: #3D3F47;
  background: white;
}
.content-filter .filter-button.selected {
  color: #3D3F47 !important;
}
.content-filter .filter-button.type-video {
  color: #FF9191;
}
.content-filter .filter-button.type-video:hover {
  border: 1px solid #FF9191;
}
.content-filter .filter-button.type-video.selected {
  background-color: #FF9191;
}
.content-filter .filter-button.type-podcast {
  color: #65BEA1;
}
.content-filter .filter-button.type-podcast:hover {
  border: 1px solid #65BEA1;
}
.content-filter .filter-button.type-podcast.selected {
  background-color: #65BEA1;
}
.content-filter .filter-button.type-research {
  color: #FF9258;
}
.content-filter .filter-button.type-research:hover {
  border: 1px solid #FF9258;
}
.content-filter .filter-button.type-research.selected {
  background-color: #FF9258;
}
.content-filter .filter-button.type-insights {
  color: #A891C7;
}
.content-filter .filter-button.type-insights:hover {
  border: 1px solid #A891C7;
}
.content-filter .filter-button.type-insights.selected {
  background-color: #A891C7;
}
.content-filter .filter-button.type-practical {
  color: #50ACD4;
}
.content-filter .filter-button.type-practical:hover {
  border: 1px solid #50ACD4;
}
.content-filter .filter-button.type-practical.selected {
  background-color: #50ACD4;
}
.content-filter .filter-button.type-link {
  color: #50ACD4;
}
.content-filter .filter-button.type-link:hover {
  border: 1px solid #50ACD4;
}
.content-filter .filter-button.type-link.selected {
  background-color: #50ACD4;
}
.content-filter .filter-button.type-reflection {
  color: #A891C7;
}
.content-filter .filter-button.type-reflection:hover {
  border: 1px solid #A891C7;
}
.content-filter .filter-button.type-reflection.selected {
  background-color: #A891C7;
}
.content-card {
  border-radius: 20px;
  background-repeat: no-repeat;
  background-position: center top;
  width: 380px;
  height: 330px;
  position: relative;
  max-width: 380px;
  flex-basis: 33.33%;
  background-color: #3D3F47;
  box-shadow: inset 0 0 1px #ccc;
}
.content-card:hover {
  cursor: pointer;
}
.content-card:hover .content-bottom h5 {
  color: #6DCC09;
}
.content-card .content-bottom {
  position: absolute;
  bottom: 0px;
  padding: 0px 15px 15px 15px;
  width: 100%;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: #3D3F47;
}
.content-card .content-bottom h5 {
  color: #FFF;
  font-family: "Campton-Bold";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px;
  margin-bottom: 10px;
}
.content-card .content-bottom p {
  font-family: "Campton-light";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.contents {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  width: 1200px;
}
.theme-layout {
  display: flex;
  width: 100%;
  min-height: 100vh;
  background: #1b1c2a;
  border-radius: 20px;
  overflow: hidden;
}
.theme-sidebar {
  width: 240px;
  flex-shrink: 0;
  background: #13141f;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  padding: 48px 0 28px;
  display: flex;
  flex-direction: column;
}
.theme-sidebar-label {
  color: rgba(255, 255, 255, 0.62);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding: 0 16px;
  margin-bottom: 14px;
}
.theme-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px 12px 12px;
  border: none;
  border-left: 4px solid transparent;
  background: transparent;
  font-family: inherit;
  transition: background 0.12s ease;
  cursor: pointer;
}
.theme-row:hover {
  background: rgba(255, 255, 255, 0.035);
}
.theme-row.active {
  background: rgba(255, 255, 255, 0.07);
}
.theme-row.active .theme-row-label {
  color: #fff;
  font-weight: 700;
}
.theme-row.active .theme-row-count {
  color: rgba(255, 255, 255, 0.78);
}
.theme-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.5);
}
.theme-dot.all {
  background: #ffffff;
}
.theme-row-label {
  flex: 1;
  text-align: left;
  color: rgba(255, 255, 255, 0.72);
  font-family: "Campton-Bold";
  font-size: 13px;
  font-weight: 400;
  line-height: 1.35;
}
.theme-row-count {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.58);
  font-size: 11px;
}
.theme-main {
  flex: 1;
  min-width: 0;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.theme-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.theme-header-bar {
  width: 4px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 2px;
}
.theme-header-title {
  margin: 0;
  color: #ffffff;
  font-family: "Campton-Bold";
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}
.theme-header-count {
  color: rgba(255, 255, 255, 0.62);
  font-size: 12px;
  margin-top: 2px;
}
.content-filter.pill {
  margin: 0;
  flex-shrink: 0;
}
.content-filter.pill .filter-button {
  margin-right: 10px;
  padding: 8px 16px;
}
.contents.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 14px;
  width: auto;
  align-content: start;
}
.contents.grid .content-card {
  width: auto;
  max-width: none;
  height: auto;
  background: #252636;
  box-shadow: none;
  display: flex;
  flex-direction: column;
}
.contents.grid .content-card:hover .content-info h5 {
  color: #6DCC09;
}
.contents.grid .content-thumb {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  background-size: cover;
  background-position: center;
  background-color: #13141f;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.contents.grid .content-thumb-play {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}
.contents.grid .content-thumb-complete {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
}
.contents.grid .content-thumb-complete img {
  width: 100%;
  height: 100%;
}
.contents.grid .content-info {
  padding: 10px 12px 11px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.contents.grid .content-info .badges {
  margin: 0;
  gap: 7px;
}
.contents.grid .content-info .badges .badge-type {
  margin: 0;
}
.contents.grid .content-info .duration-label {
  color: rgba(255, 255, 255, 0.68);
  font-size: 11px;
  font-weight: 600;
}
.contents.grid .content-info h5 {
  margin: 0;
  color: #ffffff;
  font-family: "Campton-Bold";
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
/*# sourceMappingURL=library.component.css.map */
